import { createStore } from 'vuex'

export default createStore({
  state: {
    // newData: {},
  },
  getters: {
  },
  mutations: {
    // SET_NEW_DATA(state, value) {
    //   state.newData = value;
    // },
  },
  actions: {
  },
  modules: {
  }
})
